// extracted by mini-css-extract-plugin
module.exports = {"Container":"Controls_Container__aWaKF","Controls":"Controls_Controls__F2pnW","Buttons":"Controls_Buttons__1XvfA"};